export const LOCATION_CLASSES_FETCH_STARTED = 'LOCATION_CLASSES_FETCH_STARTED';
export const LOCATION_CLASSES_FETCH_COMPLETED = 'LOCATION_CLASSES_FETCH_COMPLETED';
export const LOCATION_CLASSES_FETCH_FAILED = 'LOCATION_CLASSES_FETCH_FAILED';
